import React, { FunctionComponent } from 'react';

import { Route } from 'react-router-dom';

import { FunnelType, StepProps, FunnelState } from 'scenes/common/types';
import { route } from 'scenes/common/helpers/route';

type QuoteRouterProps<
  F,
  S extends PropertyKey,
  T extends FunnelState<F, S>,
  SP extends StepProps<F, S, T>
> = {
  stepProps: SP;
  stepRoutes: { [s in S]: FunctionComponent<SP> };
  productType: FunnelType;
};

function FlowRouter<
  F,
  S extends PropertyKey,
  T extends FunnelState<F, S>,
  SP extends StepProps<F, S, T>
>({ stepRoutes, stepProps, productType }: QuoteRouterProps<F, S, T, SP>) {
  return (
    <>
      {Object.entries<FunctionComponent<SP>>(stepRoutes).map(
        ([stepName, Component]) => (
          <Route key={stepName} path={route(productType, stepName)}>
            <Component {...stepProps} />
          </Route>
        )
      )}
    </>
  );
}

export default FlowRouter;
